export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.access-control': 'Access Control',
  'menu.access-control.role-management': 'Role Management',
  'menu.access-control.menu-management': 'Menu Management',
  'menu.access-control.user-management': 'User Management',
  'menu.device-control.category-device': 'Category Management',
  'menu.device-control': 'Device Control',
  'menu.device-control.list-device': 'Device List',
  'menu.device-control.series-device': 'Device Series',
  'menu.device-control.region-device': 'Device Region',
  'menu.device-control.model-device': 'Device Model',
  'menu.device-control.config-group-device': 'Config Group Device',
  'menu.device-control.config-device': 'Config Device',
  'menu.device-control.drink-list': 'Drink List',
  'menu.device-control.device-upgrade-package': 'Device Upgrade Package',
  'menu.device-control.device-manual-document': 'Device Manual Document',
  'menu.device-control.beverage-information': 'Beverage Information',
  'menu.application-management': 'Application Management',
  'menu.application-management.application-account': 'Application Account',
  'menu.application-management.application-agreement': 'Application Agreement',
  'menu.package-management.application-upgrade-package': 'Application Upgrade Package',
  'menu.package-management.coffee-upgrade-package': 'Application User Device',
  'menu.order-control': 'Order Control',
  'menu.order-control.list-order': 'Order List',
  'menu.package-management': 'Package Management',
  'menu.package-management.list-package': 'Package List',
};
